import React from 'react';
import { Trans } from 'react-i18next';
import { useDismissableNotification } from '../../../Notifications/Notification/useDismissableNotification';
import UserLink from '../../../User/Link/UserLink';
import s from './CommentReminderNotification.scss';
var CommentReminderNotification = function (_a) {
    var deviation = _a.deviation, id = _a.id, queueName = _a.queueName;
    var _b = useDismissableNotification({
        id: id,
        queueName: queueName,
        duration: 5000,
    }), onPause = _b.onPause, onUnpause = _b.onUnpause;
    return (
    // this chimera is supposed to be a tooltip but behaving like a notification
    // worst of both worlds ftw
    React.createElement("div", { className: s['root'], onMouseEnter: onPause, onMouseLeave: onUnpause },
        React.createElement(Trans, { i18nKey: "actionbar.comment.reminder" },
            "Leave a comment to make",
            ' ',
            React.createElement("span", { className: s['username'] },
                React.createElement(UserLink, { user: deviation.author }),
                "'s"),
            ' ',
            "day")));
};
CommentReminderNotification.displayName = 'CommentReminderNotification';
export default CommentReminderNotification;
//# sourceMappingURL=CommentReminderNotification.js.map